export default "__VITE_ASSET__BhoJ4J90__"